module.exports = __webpack_public_path__ + "img/asset_delete.bc71acb8.svg";